import { render, staticRenderFns } from "./photo-gallery.vue?vue&type=template&id=190f9f90&scoped=true&"
import script from "./photo-gallery.vue?vue&type=script&lang=js&"
export * from "./photo-gallery.vue?vue&type=script&lang=js&"
import style0 from "./photo-gallery.vue?vue&type=style&index=0&id=190f9f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190f9f90",
  null
  
)

export default component.exports